import { ReactElement } from 'react';

interface InputProps {
    title: string,
    type: string,
    name: string,
    value: string,
    onChange:(e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function InputField(props:InputProps): ReactElement<InputProps>{
    return(
        <div className="form-set">
        <dl>
            <dt className="fsz-m1 fw-b">
                {props.title}
                {props.name === 'password2' &&
                <span className="stxt">(再確認)</span>
            }
            
            </dt>
            
            <dd>
                <fieldset className="frm-tx-box">
                    <label className="frm-lb">
                        <input 
                            type={props.type} 
                            className="input-sub size-m2" 
                            name={props.name} 
                            value={props.value}
                            onChange={props.onChange}
                            autoComplete={props.name}
                        />
                    </label>
                </fieldset>
            </dd>
        </dl>
    </div>
    );
}